import styled from 'styled-components';
import { helpDeskButtonDiameter } from '../constants/helpDesk';

export const Footer = styled.div`
  flex-shrink: 0;
  min-height: ${helpDeskButtonDiameter};
`;
